import React from 'react';
import { PromoBanner } from '../components/PromoBanner';
import { HeroImage } from '../components/HeroImage';
import { SectionImage } from '../components/SectionImage';
import { SectionImage2 } from '../components/SectionImage2';
import { SectionImage3 } from '../components/SectionImage3';
import { ProductSection } from '../components/ProductSection';
import { SectionImage4 } from '../components/SectionImage4';
import { ReviewsSection } from '../components/ReviewsSection';
import { SectionImageDouble } from '../components/SectionImageDouble';
import { SectionImage5 } from '../components/SectionImage5';
import { ReviewsSectionNew } from '../components/ReviewsSectionNew';
import { OfertaSection } from '../components/OfertaSection';
import { FaqSection } from '../components/FaqSection';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-127">
      <PromoBanner data-id="element-128" />
      <HeroImage data-id="element-129" />
      <SectionImage data-id="element-130" />
      <SectionImage2 data-id="element-131" />
      <SectionImage3 data-id="element-132" />
      <ProductSection data-id="element-133" />
      <SectionImage4 data-id="element-134" />
      <ReviewsSection data-id="element-135" />
      <SectionImageDouble data-id="element-136" />
      <SectionImage5 data-id="element-137" />
      <ReviewsSectionNew data-id="element-138" />
      <OfertaSection data-id="element-139" />
      <FaqSection data-id="element-140" />
    </main>;
}